import { useContext } from 'react';
import FormInput from '../AboutOneForm/FormInput';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { useDispatch } from 'react-redux';
import { setSelectedDesktopFeatureOneSection } from '../../../../../Features/storefrontSlice';
import ImageInput from './ImageInput';
import MinusRed from '../../../../../Assets/StorefrontIcons/MinusRed.svg';

function FeatureSection({ index, feature, isSelected, isFirst, formErrors, onRemove, featuresLength }) {
    const dispatch = useDispatch();

    const {
        setFeaturesOneDesktop,
    } = useContext(StorefrontContext);

    function handleSelectFeatureSection() {
        dispatch(setSelectedDesktopFeatureOneSection(feature.title));
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFeaturesOneDesktop((prevFeature) =>
            prevFeature.map((item) =>
                item.title === feature.title
                    ? { ...item, [name]: value } 
                    : item
            )
        );
    }

    return (
        <div className='flex flex-col'>
            <button onClick={handleSelectFeatureSection} className={`outline-none bg-[#FFFFFF] ${isSelected && 'bg-[#FAFAFA]'} hover:bg-[#FAFAFA] ${!isFirst && 'border-t border-[#EAEAEA]'} p-3 flex items-center justify-between`}>
                <p className='text-base text-[#000000] font-semibold'>{feature.title}</p>

                {featuresLength > 1 && !isSelected && (
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove(index);
                        }}
                        className="size-6 flex items-center justify-center transition-all duration-300 ease-linear"
                    >
                        <img src={MinusRed} alt="remove" />
                    </button>
                )}
            </button>

            {
                isSelected && 
                <div className='flex flex-col gap-3 p-3'>
                    <ImageInput 
                        feature={feature} 
                        errorText={formErrors[`${feature.title}-image`]} 
                    />

                    <FormInput 
                        errorText={formErrors[`${feature.title}-altText`]} 
                        inputOptions={{
                            name: "altText",
                            id: "altText",
                            placeholder: 'Describe your image for people with visual impairments',
                            value: feature.altText,
                            onChange: handleChange,
                        }} 
                        title='Alt Text' 
                    />

                    <FormInput 
                        errorText={formErrors[`${feature.title}-heading`]} 
                        inputOptions={{
                            name: "heading",
                            id: "heading",
                            placeholder: 'Write heading here',
                            value: feature.heading,
                            onChange: handleChange,
                        }} 
                        title='Heading' 
                    />

                    <FormInput 
                        errorText={formErrors[`${feature.title}-description`]} 
                        inputOptions={{
                            name: "description",
                            id: "description",
                            placeholder: 'Write description here',
                            value: feature.description,
                            onChange: handleChange,
                        }} 
                        title='Description' 
                    />
                </div>
            }
        </div>
    );
}

export default FeatureSection;
